<template>
	<app>
		<crumb-bar></crumb-bar>
		<menu-aside>
			<m-operate v-if="power('7')">
				<c-button icon="add" @click="navigateTo('/transact/person_change/apply', true)">申请变更</c-button>
			</m-operate>
			
			<c-table ref="table">
				<c-table-column
					label="状态"
					width="100"
				>
					<template v-slot="{data}">
						<span v-if="personState[data.state]" :style="{'color': personState[data.state].color}">{{personState[data.state].name}}</span>
					</template>
				</c-table-column>
					
				<c-table-column
					label="项目名称"
					name="project_name"
					width="260"
				></c-table-column>
				
				<c-table-column
					label="项目经理"
					name="xmjl_xm"
					width="120"
				></c-table-column>
				
				<c-table-column
					label="技术总工"
					name="jszg_xm"
					width="120"
				></c-table-column>
				
				<c-table-column
					label="申请时间"
					name="create_date"
					width="160"
				></c-table-column>
				
				<c-table-column
					type="button"
					label="操作"
					width="160"
				>
					<template v-slot="{data}">
						<c-table-button v-if="data.state == 4 && power('7')" @click="navigateTo('/transact/person_change/edit', {id: data.id}, true)">重新编辑</c-table-button>
						<c-table-button v-if="data.state == 1 && power('8')" @click="navigateTo('/transact/person_change/detail', {id: data.id}, true)">审批</c-table-button>
						<c-table-button v-else @click="navigateTo('/transact/person_change/detail', {id: data.id}, true)">详情</c-table-button>
						<c-table-button v-if="data.state == 4 && power('7')" @click="deleteHandle(data)">删除</c-table-button>
					</template>
				</c-table-column>
			</c-table>
		</menu-aside>
	</app>
</template>

<script>
	import {mapGetters} from 'vuex'
	
	export default {
		computed: {
			...mapGetters(['power', 'personState'])
		},
		
		mounted() {
			this.updateList();
		},
		
		methods: {
			updateList() {
				this.$refs.table.load({
					url: '/project/ry/list'
				});
			},
			
			deleteHandle(data) {
				this.$confirm({
					text: '确定要删除此变更申请吗？',
					resolve: () => {
						this.request({
							url: '/project/ry/delete',
							data: {
								ry_id: data.id
							},
							loading: true,
							success: () => {
								this.$message({
									text: '删除成功'
								});
								this.$refs.table.update();
							}
						});
					}
				});
			}
		}
	}
</script>

<style lang="stylus" scoped>
</style>
